import {
  Injector,
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf
} from '@angular/core';
import { UnitService } from './services/unit.service';

@NgModule({
})
export class UnitModule {

  static injector: Injector;

  constructor(@Optional() @SkipSelf() parentModule: UnitModule, injector: Injector) {
    if (parentModule) {
      throw new Error('UnitModule is already loaded. Import it in the AppModule only');
    }
    UnitModule.injector = injector;
  }

  static forRoot(): ModuleWithProviders<UnitModule> {
    return {
      ngModule: UnitModule,
      providers: [UnitService]
    };
  }
}
